/**
 * Feature flag that controls if a user can use a credit card to check out.
 * If prefixed with * or no prefix at all, all countries will be able to check out.
 * If prefixed with a country code, then only applied to that country.
 */
export const FLAG_STRIPE_PAYMENTS = "-stripe-payments";
export const FLAG_COOKIE_SETTINGS = "cookie-settings";
export const FLAG_SHOP_2 = "shop-2";
export const FLAG_SHOP_2_WITH_EVENTS = "shop-2-events";
export const FLAG_SHOP_ONLINE_VIDEOS = "shop-online-videos";

const f = {
    FLAG_STRIPE_PAYMENTS,
    FLAG_COOKIE_SETTINGS,
    FLAG_SHOP_2,
    FLAG_SHOP_2_WITH_EVENTS,
    FLAG_SHOP_ONLINE_VIDEOS,
};

export default f;